__turbopack_context__.v({
  "alignRight": "LQA7kW_alignRight",
  "button": "LQA7kW_button",
  "left": "LQA7kW_left",
  "root": "LQA7kW_root",
  "title": "LQA7kW_title",
});
